import { Component, OnInit } from "@angular/core";
import api from "../api";
import { HttpBaseService } from "../services/httpBase.service";
import { GetSessionStore } from "../services/comment";
@Component({
  selector: "app-slider",
  templateUrl: "./slider.component.html",
  styleUrls: ["./slider.component.css"]
})
export class SliderComponent implements OnInit {
  constructor(private http: HttpBaseService) {}
  array: Array<any>;
  certificate = JSON.parse(GetSessionStore("successLoginInfo")).certificate;
  nzAutoPlay=false;
  ngOnInit() {
    // setTimeout(_ => {
    //   this.array = [
    //     { img: "assets/images/au6/AusnutriaBack.jpg" },
    //     { img: "assets/images/au1/1897back.jpg" }
    //   ];
    // }, 500);

    // this.http.post(
    //     api.CarouselList,
    //     {
    //       params: JSON.stringify({
    //         carouselPosition: "PORTAL",
    //         displayFlag: "Y",
    //         orderBy: "order_sequence",
    //         sort: "asc"
    //       })
    //     }
    //   )
    //   .subscribe(res => {
    //     if (res.status === "S") {
    //       this.array = res.data;
    //       if (this.array.length > 0) {
    //         this.nzAutoPlay=true;
    //         this.array.map( item => {
    //           item.pictureUrl = item.pictureUrl.replace(/http:|https:/im, '');
    //         });
    //       }
    //     }
    //
    //   });
  }
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/slider/slider.component.ts